export const GAMES = {
  DICE: 'dice',
  BALLS: 'balls',
  ROULETTE: 'roulette',
};
